import React from 'react';
import { EmployerCertificateHeader } from './employer-certificate-header.component';
import { EmployerCertificateStats } from './employer-certificate-stats.component';
import { CertificatesTable } from './certificates-table.component';
import './employer-certificate-list.component.scss';

interface EmployerCertificateListProps {
    onOrderCertificate: () => void;
}

export const EmployerCertificateList: React.FC<EmployerCertificateListProps> = ({
    onOrderCertificate
}) => {
    return (
        <div className="employer-certificate-list">
            <div className="ec-reveal" style={{ animationDelay: '60ms' }}>
                <EmployerCertificateHeader />
            </div>
            <div className="ec-reveal" style={{ animationDelay: '140ms' }}>
                <EmployerCertificateStats />
            </div>
            <div className="ec-reveal" style={{ animationDelay: '220ms' }}>
                <CertificatesTable onOrderCertificate={onOrderCertificate} />
            </div>
        </div>
    );
};
